export const getUserNameOfCommentor = async ({
  isRos,
  rosId,
  setOpts,
  keyword,
  wheelId,
  showUser,
  streamId,
  setNoUser,
  isPolling,
  hiddenData,
  wheelState,
  setWheelState,
  setNewWheelUser,
  isKeywordEnabled,
  getCommentsDetails,
  setInteractionState,
  setForPoolingInteraction,
  turncateWinningWheelOpt
}) => {
  if (wheelState === 'spin' || !isRos) return;
  const wheelUser = showUser;
  const payload = JSON.stringify({
    keyword: isKeywordEnabled ? keyword : '',
    wheelId,
    isPolling
  });
  const encodedData = encodeURIComponent(payload);

  const res = await getCommentsDetails(streamId, wheelUser, encodedData);
  if (!res?.status) return;

  const entities = res?.entity || [];

  const hiddenList = hiddenData[rosId] || [];
  const users = entities?.filter(opt => !hiddenList.includes(opt.id));

  setOpts(users.map(u => ({ id: u.id, body: turncateWinningWheelOpt(u.body) })));
  setNewWheelUser(users);

  if (users.length === 0) {
    setNoUser(true);
    setWheelState('empty');
    setForPoolingInteraction(!isKeywordEnabled);
    return;
  }

  setNoUser(false);
};
